


















import Vue, { PropType } from 'vue';
import { IWorkflowFormFieldNode, WorkflowFormFieldNode } from '@/models';

import { ComputationNodeSubtype } from '@/models/computation/computation.constants';
import { IFieldErrors } from '@/models/error';

import { inject as RegistrableInject } from '@/mixins/registrable';
import BindsAttrs from '@/mixins/binds-attrs';
import mixins from '@/utils/mixins';

import { requiredValidator } from '@/utils/validators';
import WorkflowFormBuilderFieldMetaLabelAutoPicker from './WorkflowFormBuilderFieldMetaLabelAutoPicker.vue';
const baseMixins = mixins(
  BindsAttrs,
  RegistrableInject<'formExpression', any>('formExpression')
);

type ErrorBag = Record<number, boolean>;
interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: Vue & {
      validate: () => boolean;
      resetValidation: () => void;
      reset: () => void;
    };
  };
}
export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'WorkflowFormBuilderFieldNodeOperandNode',

    components: {
      WorkflowFormBuilderFieldMetaLabelAutoPicker
    },

    props: {
      value: {
        type: Object as PropType<IWorkflowFormFieldNode>
      },

      fieldError: {
        type: Object as PropType<IFieldErrors>,
        default: () => ({})
      },

      disabled: {
        type: Boolean,
        default: false
      },

      firstNode: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        valid: false,
        errorBag: {} as ErrorBag
      };
    },

    computed: {
      hasError(): boolean {
        return !this.valid;
      },

      internalValue: {
        get(): IWorkflowFormFieldNode {
          return this.value;
        },
        set(val: IWorkflowFormFieldNode) {
          // hack for passing multiple function on the emit values
          this.$emit('input', val);
        }
      }
    },

    methods: {
      requiredValidator,

      updateInternalValue(node: IWorkflowFormFieldNode) {
        this.internalValue = node;
      },

      setVariableName(variable_name: string) {
        const newNode = new WorkflowFormFieldNode({
          id: this.internalValue.id,
          type: this.internalValue.type,
          subtype: this.internalValue.subtype,
          order: this.internalValue.order,
          variable_name: variable_name,
          constant: null
        });
        this.updateInternalValue(newNode);
      },

      /** @public */
      reset() {
        const newNode = new WorkflowFormFieldNode({
          id: this.internalValue.id,
          type: this.internalValue.type,
          order: this.internalValue.order,
          subtype: ComputationNodeSubtype.Constant
        });
        this.updateInternalValue(newNode);
        return this.$refs['form'].reset();
      },

      /** @public */
      resetValidation() {
        return this.$refs['form'].resetValidation();
      },

      validate(): boolean {
        return this.$refs['form'].validate();
      }
    },

    created() {
      this.formExpression && this.formExpression.register(this);
    },

    beforeDestroy() {
      this.formExpression && this.formExpression.unregister(this);
    }
  });
